import {ThemeDefinition} from '@volkswagen-onehub/components-core';

export type DesignVariant = 'v19' | 'v26';

export interface ThemeWithVariant extends ThemeDefinition {
  variant?: DesignVariant;
}

/**
 * Check if the theme is using the new design variant (v26)
 */
export function isV26(theme: ThemeWithVariant): boolean {
  return theme.variant === 'v26';
}
